// extracted by mini-css-extract-plugin
export var footerContacts = "footerContacts-module--footerContacts--xapLG";
export var inner = "footerContacts-module--inner--2E_uF";
export var subscribe = "footerContacts-module--subscribe--2Ql4K";
export var socials = "footerContacts-module--socials--1mKr1";
export var contacts = "footerContacts-module--contacts--3cNzF";